<script setup lang="ts">
import type { ArrayMode } from "./batchEditItem"

defineProps<{ modelValue: ArrayMode }>()
const emit = defineEmits<{ "update:modelValue": [value: ArrayMode] }>()

const options: Array<{ value: ArrayMode; label: string; activeClass: string }> = [
  { value: "noop",    label: "Nicht ändern", activeClass: "btn-primary" },
  { value: "add",     label: "+ Hinzufügen", activeClass: "btn-primary" },
  { value: "remove",  label: "− Entfernen",  activeClass: "btn-primary" },
  { value: "replace", label: "= Ersetzen",   activeClass: "btn-error" }
]
</script>

<template>
  <div class="join" role="radiogroup">
    <button
      v-for="opt of options"
      :key="opt.value"
      type="button"
      class="btn btn-sm join-item"
      :class="{ [opt.activeClass]: modelValue === opt.value }"
      :aria-pressed="modelValue === opt.value"
      @click="emit('update:modelValue', opt.value)"
    >
      {{ opt.label }}
    </button>
  </div>
</template>
